export class ParticleManager {
    systemActive = true;
    particleSystem;
    constructor(particleSystem) {
        this.particleSystem = particleSystem;
    }
    getDefaultParticleSettings() {
        return this.particleSystem.getDefaultParticleSettings();
    }
    createEmitter(particleSetupObject) {
        this.particleSystem.setUpEmitter(particleSetupObject);
    }
    activateSystem() {
        this.particleSystem.startEmitters();
        this.systemActive = true;
    }
    isActive() {
        return this.systemActive;
    }
    deactivateSystem() {
        this.particleSystem.stopEmitters();
        this.systemActive = false;
    }
    checkActivateEmitters(quality) {
        this.particleSystem.checkActivateEmitters(quality);
    }
    getEmitter(name) {
        return this.particleSystem.getParticleEmitter(name);
    }
    update() {
        if (!this.systemActive)
            return;
        this.particleSystem.update();
    }
}
//# sourceMappingURL=ParticleManager.js.map